import { t } from "@lingui/macro"

export const ALERT_LEVELS = {
    INFO: "info",
    WARNING: "warning",
    ERROR: "error",
} as const

export type AlertLevel = typeof ALERT_LEVELS[keyof typeof ALERT_LEVELS]

export const ALERT_LEVEL_OPTIONS = [
    { value: ALERT_LEVELS.INFO, label: t`alerts.level.info` },
    { value: ALERT_LEVELS.WARNING, label: t`alerts.level.warning` },
    { value: ALERT_LEVELS.ERROR, label: t`alerts.level.error` },
] as const
